/**
 * Service to wrap environment configuration values.
 */

const configService = {
    env: process.env.VUE_APP_ENV,
		api_url: process.env.VUE_APP_API,
		enable_autosave: (process.env.VUE_APP_ENABLE_AUTOSAVE === 'true'),
		autosave_interval: process.env.VUE_APP_AUTOSAVE_INTERVAL
};

// Logs to the consol whether the auto save feature is on or off.
if (configService.enable_autosave === true) {
	console.info('Autosave is turned on');
} else {
	console.info('Autosave is turned off');
}

export { configService }
